import {ENTITY_SERVICE_REGISTRY, EntityServiceEntry} from "../../core/shared/dto/dto-service/entity-service-registry";

export const CD_ENTITY_PROVIDER = [
    {
        provide: ENTITY_SERVICE_REGISTRY,
        useValue: [
            ['cd.Contact', {route: '/cd/contacts'}],
            ['cd.ContactType', {route: '/cd/contactTypes'}],
            ['cd.ContactTypeField', {route: '/cd/contactTypeFields'}],
            ['cd.ContactTypeObjectType', {route: '/cd/contactTypeObjectTypes'}],
            // Route-only, following the {camelPlural} convention of its cd siblings above.
            // KEPT DELIBERATELY (signed capability matrix, row H2) even though it currently resolves
            // to nothing usable - do not remove without revisiting that signed row.
            // BACKEND GAP (flagged for a backend specialist, not fixed here): unlike ContactType/
            // ContactTypeField/ContactTypeObjectType, cd.ContactField has NO Controller class today -
            // only ContactFieldAccess, ContactFieldDtoDetail, the entity and the repository exist
            // (apps/backend/api/.../cd/{access,access/dto,model,model/repo}/ContactField*.java). This
            // registration lets MvsCoreService.getCrudService('cd.ContactField') resolve without
            // throwing, but any actual HTTP call through it 404s until ContactFieldController is added
            // (compare ci.InsurableObjectField, whose controller exists -
            // ci/controller/InsurableObjectFieldController.java).
            // NOT a GK8 read path: generic field values are read ONLY via the gen_<typeFieldId>
            // columns GenericTemplateMetaService/QL already expose - this entry is not, and must not
            // become, a second way to reach cd.ContactField values.
            ['cd.ContactField', {route: '/cd/contactFields'}],
        ] as EntityServiceEntry[],
        multi: true
    }
];
